import { render, staticRenderFns } from "./FocusPage.vue?vue&type=template&id=149597c8&scoped=true&"
import script from "./FocusPage.vue?vue&type=script&lang=js&"
export * from "./FocusPage.vue?vue&type=script&lang=js&"
import style0 from "./FocusPage.vue?vue&type=style&index=0&id=149597c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149597c8",
  null
  
)

export default component.exports